/* Copyright (c) 2021 Magnusson Institute, All Rights Reserved */
import React from 'react';
import { Grid, LinearProgress, Paper, Typography } from "@mui/material";
import { autorun } from 'mobx'
import SwipeableViews from 'react-swipeable-views';
import * as __ from 'lib384/dist/384.esm'
import { config } from 'config';
import SnackabraContext from 'contexts/SnackabraContext';
import SBFileHelperContext from 'contexts/SBFileHelperContext';
import { ChannelStoreType } from "react384"
import WalletContext from "../contexts/WalletContext";
import HeadphonesIcon from '@mui/icons-material/Headphones';
import Slide from '@mui/material/Slide';
import { Routes, Route } from "react-router-dom";
import PageNotFound from './errors/PageNotFound';
import AddMusic from './AddMusic';
import MusicPage from './MusicPage';
import PlayLists from './PlayLists';
import MusicLibrary from './MusicLibrary';
import SongsContext from 'contexts/core/SongsContext';
import CoversContext from 'contexts/core/CoversContext';
import AlbumsContext from 'contexts/core/AlbumsContext';
import PlayListContext from 'contexts/core/PlayListContext';
import HistoryContext from 'contexts/core/HistoryContext';
import PlayerContext, { Player } from 'contexts/core/PlayerContext';


const Home = () => {
  const benchmarker = React.useRef<{ startTime: number, endTime: number }>({ startTime: 0, endTime: 0 });
  let knownMessages = React.useRef<Map<string, string>>(new Map());
  const containerRef = React.useRef<HTMLElement>(null);
  const playListMessages = React.useRef<any>({});
  const historyMessages = React.useRef<any>({});
  let messagesInitializedTimeout = React.useRef<any>(null);

  const songsContext = React.useContext(SongsContext)
  const coversContext = React.useContext(CoversContext)
  const albumsContext = React.useContext(AlbumsContext)
  const playListContext = React.useContext(PlayListContext)
  const historyContext = React.useContext(HistoryContext)
  const [slideIn, setSlideIn] = React.useState(false);
  const wallet = React.useContext(WalletContext)
  const SBContext = React.useContext(SnackabraContext)
  const SBFH = React.useContext(SBFileHelperContext)
  const [activeStep, setActiveStep] = React.useState(0);
  const [channel, setChannel] = React.useState<ChannelStoreType | null>(null)
  const [messagesInitialized, setMessagesInitialized] = React.useState<boolean>(false)

  React.useEffect(() => {
    setTimeout(() => {
      setSlideIn(true)
      setTimeout(() => {
        const icon = document.getElementById('headphones-icon')
        icon?.classList.add('bounce')
        setTimeout(() => {
          setActiveStep(1)
        }, 750)
      }, 250)
    }, 500)
  }, [])

  React.useEffect(() => {
    if (SBContext && wallet.id && wallet.identity) {
      connect()
    }
  }, [SBContext, wallet.id, wallet.identity])

  React.useEffect(() => {

    if (messagesInitialized) {
      for (let x in playListMessages.current) {
        const _playlist = playListMessages.current[x]
        playListContext.addPlayList(_playlist)
      }
      for (let x in historyMessages.current) {
        const _history = historyMessages.current[x]
        historyContext.importMetadata(_history)
      }
      benchmarker.current.endTime = performance.now();
      const executionTime = benchmarker.current.endTime - benchmarker.current.startTime;
      console.log(`Execution time: ${executionTime} milliseconds`);
    }
  }, [messagesInitialized])

  React.useEffect(() => {
    if (channel) {
      if (channel?.messages) {
        autorun(() => {
          receiveMessages(channel?.messages)
        })
      }
    }
  }, [channel])

  const receiveMessages = React.useCallback((messages: any[]) => {
    setMessagesInitialized(false)
    for (let _m in messages) {

      if (messagesInitializedTimeout.current) clearTimeout(messagesInitializedTimeout.current)
      messagesInitializedTimeout.current = setTimeout(() => {
        setMessagesInitialized(true)
      }, 250)
      const m = messages[_m]
      if (m.hasOwnProperty('text') && !knownMessages.current.has(m._id)) {
        knownMessages.current.set(m._id, m._id)
        const contents = JSON.parse(m.text)

        const userId = `${m?.sender_pubKey?.x} ${m?.sender_pubKey?.y}`;
        m.user._id = userId;
        m.user.name = SBContext!.getContact(userId).name === 'Unamed' && m.sender_username ? m.sender_username : SBContext!.getContact(userId).name;
        m.sender_username = m.sender_username ? m.sender_username : m.user.name;

        switch (contents.messageType) {
          case 'album_v7':
            const albumn = JSON.parse(m.text)
            albumn._id = `${albumn.title + albumn.artist}`
            console.log('ALBUM ljkhfajsdgbfasjdfh', albumn)
            albumsContext.addAlbum(albumn)
            break;
          case 'audio':
            const song = JSON.parse(m.text)
            SBFH.uploadConfirmed({ shardId: song.shardId, handle: song })
            song._id = song.shardId
            console.log('SONG ljkhfajsdgbfasjdfh', song)
            break;
          case 'image':
            const image = JSON.parse(m.text)
            console.log('IMAGE ljkhfajsdgbfasjdfh', image)
            coversContext.addCover(image)
            SBFH.uploadConfirmed({ shardId: image.shardId, handle: image })
            break;
          case 'image_meta_data_v2':
            const imageMetaData = JSON.parse(m.text)
            console.log('IMAGE META DATA ljkhfajsdgbfasjdfh', imageMetaData)
            imageMetaData._id = imageMetaData.imageId + '_metadata'
            coversContext.addCoverMetadata(imageMetaData)
            break;
          case 'song_meta_data_v2':
            const songMetaData = JSON.parse(m.text)
            console.log('SONG META DATA ljkhfajsdgbfasjdfh', songMetaData)
            songsContext.addSong(songMetaData)
            break;
          case 'playlist_v2':
            const _playlist = JSON.parse(m.text)
            console.log('PLAYLIST ljkhfajsdgbfasjdfh', _playlist)
            playListMessages.current[_playlist.playlist_id] = _playlist
            break;
          case 'history_v7':
            const _history = JSON.parse(m.text)
            console.log('HISTORY ljkhfajsdgbfasjdfh', _history)
            _history._id = _history.songId
            historyMessages.current[_history._id] = _history
            break;
          default:
            console.warn("Unknown message type received: ", m);
            console.log(JSON.parse(m.text))
        }
      }
    }
  }, [])

  const connect = async () => {
    if (!SBContext) throw new Error('SBContext is null')
    if (!wallet.id) throw new Error('walletId is undefined')
    if (!wallet.identity) throw new Error('walletKey is undefined')
    console.log('connect', wallet.id, wallet.identity)
    if (!SBContext.channels[wallet.id]) {
      await SBContext.join(wallet.id, wallet.identity)
    }
    const _c = SBContext.channels[wallet.id] as ChannelStoreType
    console.log(_c)
    _c.connect().then((c: any) => {
      benchmarker.current.startTime = performance.now();
      setChannel(_c)
    })

  }

  const playMusic = (_playList: any) => {
    // console.log(playList)
    // playerContext.setPlaylist(_playList)
    // setActiveStep(2)
  }

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const afterSwipe = (index: number, lastIndex: number) => {
    console.log(index, lastIndex)
    setActiveStep(index)
  }


  return (
      <Grid
        sx={{
          position: 'relative',
          padding: 0, width: '100vw', background: 'none',
          height: '100vh',
          backgroundImage: `url('/images/splashpage.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <Paper sx={{ p: 0,zIndex: 3, height: '100%', width: '100%', backgroundColor: activeStep === 0 ? 'transparent' : '#121212' }}>
          <SwipeableViews style={{ zIndex: 3,padding: 0 }} index={activeStep} disabled={activeStep >= 1} onChangeIndex={afterSwipe}>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              sx={{ height: '100vh', width: '100%', p: 3 }}
            >
              <Grid item xs={12}>
                <Slide in={slideIn} container={containerRef.current} direction='left'>
                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ overflow: 'hidden', minHeight: 125 }}
                  >
                    <Grid item>
                      <Typography variant="h4" component="div" sx={{ flexGrow: 1 }}>
                        384
                      </Typography>
                    </Grid>

                    <HeadphonesIcon id={'headphones-icon'} className={'rotate-initial'} sx={{ fontSize: 36, color: "#FF5C42" }} />
                  </Grid>
                </Slide>
              </Grid>

            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              sx={{ p: 3 }}
            >
              <Grid item xs={12}>
                <Routes>
                  <Route path="/" element={<MusicPage />} />
                  <Route path="/a" element={<AddMusic />} />
                  <Route path="/l" element={<MusicLibrary play={playMusic} />} />
                  <Route path="/p" element={<PlayLists play={playMusic} />} />
                  <Route path="*" element={<PageNotFound />} />
                </Routes>
              </Grid>

            </Grid>
            <Grid />
          </SwipeableViews>

        </Paper>
      </Grid>
  )
}

export default Home;


